export default __webpack_public_path__ + "6e5274085f6321d02681341b6c775450.png";